/**
 * Typed API client for the Extranet (external client portal) — admin surface.
 *
 * Tenant admins invite external users (clients/contacts) to a restricted
 * portal, then set their initial password. Mirrors internal/extranet.
 */

import { apiClient } from '@/lib/apiClient';

export interface ExtranetUser {
  id: string;
  email: string;
  name: string;
  companyAccountId?: string | null;
  contactId?: string | null;
  invitedAt: string;
  activatedAt?: string | null;
  lastLoginAt?: string | null;
  enabled: boolean;
}

export async function listExtranetUsers(): Promise<ExtranetUser[]> {
  const { data } = await apiClient.get<ExtranetUser[]>('/extranet');
  return data;
}

export interface InviteExtranetUserRequest {
  email: string;
  name: string;
  companyAccountId?: string | null;
  contactId?: string | null;
}

export async function inviteExtranetUser(req: InviteExtranetUserRequest): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>('/extranet', req);
  return data;
}

export async function setExtranetPassword(id: string, password: string): Promise<{ ok: boolean }> {
  const { data } = await apiClient.post<{ ok: boolean }>(`/extranet/${id}/set-password`, { password });
  return data;
}
